export default {
  // success messages

  // error messages
  ERROR_SET_NOTICE_VIEWED_BY_USER: "There was an error setting this notice as viewed",
};
